import styled from 'styled-components';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import { useState } from 'react';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import { useStoreInfosValueContextHook } from '../../../../contexts/StoreInfosContext';
const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .info-box{
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 12px;
    font-weight: 600;
  }

  button{
    padding: 0;
    font-size: 10px;
    font-weight: 600;
    color: #fff;
    background-color: #6c757d;
    border: 1px solid #6c757d;
    border-radius: 3px;
    height: 20px;
    width: 70px;
  }
`

const StyledModalHeader = styled.div`
    padding: 10px;
`;

const StyledModalBody = styled.div`
    padding: 10px;
`;

const StyledModalFooter = styled.div`
    padding: 10px;

    button{
        border:none;
        background-color: #333;
        color:#fff;
        font-weight: 600;
        border-radius: 3px;
    }
`;

export function TdOrderNumberInfo({
    returnExchange
}) {
    const [talkTalkOpenerModalOpen, settalkTalkOpenerModalOpen] = useState(false);
    const storeInfosValueContextHook = useStoreInfosValueContextHook();
    const storeInfo = storeInfosValueContextHook.storeInfos?.find(r => r.id === returnExchange?.salesChannelMatchingStoreId);
    const storeCode = STORE_CODES[storeInfo?.id];

    return (
        <>
            <StyledTableCell>
                <div className='info-box'>
                    <div>{returnExchange?.orderNumber1}</div>
                    {storeInfo?.storeType === 'COMMERCE_API' &&
                        <div>
                            <CustomBlockButton
                                type='button'
                                onClick={() => {
                                    window.open(`https://sell.smartstore.naver.com/o/v3/oa/biztalk/${returnExchange?.orderNumber1}`, 'popupWindow', 'width=600,height=400');
                                    settalkTalkOpenerModalOpen(true);
                                }}
                            >
                                톡톡쓰
                            </CustomBlockButton>
                        </div>
                    }
                </div>
            </StyledTableCell>
            {talkTalkOpenerModalOpen &&
                <TalkTalkOpenerModal
                    open={talkTalkOpenerModalOpen}
                    onClose={() => settalkTalkOpenerModalOpen(false)}
                    storeCode={storeCode}
                />
            }
        </>
    );
}

function TalkTalkOpenerModal({
    open,
    onClose,
    storeCode
}) {
    const [memberId, setMemberId] = useState('');

    const handleOpen = () => {
        //     window.open(`https://partner.talk.naver.com/chat/ct/${storeCode}/${memberId}?mode=popup`, 'popupWindow', 'width=600,height=400');
        window.open(`https://partner.talk.naver.com/chat/ct/${storeCode}/${memberId}?`, 'popupWindow', 'width=600,height=400');
        onClose();
    }

    return (
        <>
            <CustomDialog
                open={open}
            >
                <StyledModalHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>톡톡쓰 오픈</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()}>닫기</CustomDialog.Header.Close>
                    </CustomDialog.Header>
                </StyledModalHeader>
                <form onSubmit={(e) => { e.preventDefault(); handleOpen() }}>
                    <StyledModalBody>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={memberId || ''}
                                onChange={(e) => setMemberId(e.target.value)}
                                autoFocus
                            />
                            <CustomLabelInput.Label>멤버아이디</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledModalBody>
                    <StyledModalFooter>
                        <CustomBlockButton
                            type='submit'
                        >
                            열기
                        </CustomBlockButton>
                    </StyledModalFooter>
                </form>
            </CustomDialog>
        </>
    )
}

const STORE_CODES = {
    "e2fa1155-8e54-48ae-be4c-cfc77bef19d9": "wcsrr1", // 니뜰리히
    "928c3a99-7acf-4869-bb07-cdeb6c7588ad": "wce1wv", // 수비다
    "0877c607-3849-4a6d-902e-4bb29306351d": "w4g8ot", // 노는개
    "c483aaf6-7a82-4b51-9ece-11222a80eb1a": "w48val", // 아르빙
    "005570f7-adac-4ebb-a57d-a6e7fd012389": "wjuy6vm" // 일단담아.
}